import {
  Component,
  ViewEncapsulation,
  Output,
  EventEmitter,
  Input
} from '@angular/core';


@Component({
  selector: 'app-drop-down',
  template: `this is a test!


this is a test!this is a test!this is a test!this is a test!this is a test!


this is a test!this is a test!this is a test!this is a test!this is a test!

this is a test!this is a test!this is a test!this is a test!this is a test!




`,
  styles: [``],
  encapsulation: ViewEncapsulation.None
})
export class DropDownComponent {
  constructor() {
  }
  openDropdown(event) {
  }

 searchOptions(event: any) {
  }

 imageErrorHandler(event) {
  }
  changeOption(event: any, data: any, isDisabledOptionClicked = false) {
  }
  checkIfObject() {
  }
}
